export default __webpack_public_path__ + "static/michalPasierbiewicz-a1692ece0154f58462a550469c67053e.png";